// extracted by mini-css-extract-plugin
module.exports = {"root":"BWLoYaaQXYuMUAvyrYdT","content":"TZaS3Vmz6sxsXE2J5xXl","label":"ORsHOy9rwgv6B6axJ1xu"};